<template>
        <div>
            <h3 v-if="!this.isAddEquipmentMode" class="editor-header px-2">
                {{ $t('lighting.editor_title')  }}
            </h3>
            <location-deviation v-if="!this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div v-if="!this.isAddEquipmentMode" class="row">
                    <div class="col-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('fence.type') }}</span>
                       <select
                           v-model="item.type"
                           class="form-select form-select-sm"
                           :disabled="!this.isAddEquipmentMode"
                       >
                           <option :value="null" :disabled="!this.isAddEquipmentMode">
                               {{ $t('post.select_type') }}
                           </option>
                           <option
                               v-for="item in getLightingTypes()"
                               :key="item.value"
                               :value="item.value"
                           >
                               {{ item.name }}
                           </option>
                       </select>
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('lighting.post_material') }}</span>
                       <select
                           v-model="item.post_material"
                           class="form-select form-select-sm"
                           :disabled="!this.isAddEquipmentMode"
                       >
                           <option :value="null" :disabled="!this.isAddEquipmentMode">
                               {{ $t('lighting.select_post_material') }}
                           </option>
                           <option
                               v-for="item in getMaterials()"
                               :key="item.value"
                               :value="item.value"
                           >
                               {{ item.name }}
                           </option>
                       </select>
                   </div>
                    <div class="col-sm-4">
                        <condition-selector :disabled="!this.isAddEquipmentMode" v-model="item.condition" :required="true"/>
                    </div>
                </div>
                <div v-if="item.location_specification" class="row">
                    <location-details
                        v-if="!this.isAddEquipmentMode"
                        :lane-data="item.location_specification.lane"
                        :side-data="item.location_specification.side"
                        :track-data="item.location_specification.tracks"
                    />
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('railing.material') }}</span>
                        <select
                            v-model="item.material"
                            class="form-select form-select-sm"
                            :disabled="!this.isAddEquipmentMode"
                        >
                            <option :value="null" :disabled="!this.isAddEquipmentMode">
                                {{ $t('railing.select_material') }}
                            </option>
                            <option
                                v-for="item in getMaterials()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('lighting.lamp_types.title') }}</span>
                        <select
                            v-model="item.lamp_type"
                            class="form-select form-select-sm"
                            :disabled="!this.isAddEquipmentMode"
                        >
                            <option :value="null" :disabled="!this.isAddEquipmentMode">
                                {{ $t('lighting.lamp_types.select_lamp_type') }}
                            </option>
                            <option
                                v-for="item in getLightingLampTypes()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('lighting.cable_installation_method.title') }}</span>
                        <select
                            v-model="item.cable_installation_method"
                            class="form-select form-select-sm"
                            :disabled="!this.isAddEquipmentMode"
                        >
                            <option :value="null" :disabled="!this.isAddEquipmentMode">
                                {{ $t('lighting.cable_installation_method.select_method') }}
                            </option>
                            <option
                                v-for="item in getLightingCableInstallationMethods()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('lighting.post_types.title') }}</span>
                        <select
                            v-model="item.post_type"
                            class="form-select form-select-sm"
                            :disabled="!this.isAddEquipmentMode"
                        >
                            <option :value="null" :disabled="!this.isAddEquipmentMode">
                                {{ $t('lighting.post_types.select_post_type') }}
                            </option>
                            <option
                                v-for="item in getPostTypes()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('lighting.safety_classes.title') }}</span>
                        <select
                            v-model="item.post_safety_class"
                            class="form-select form-select-sm"
                            :disabled="!this.isAddEquipmentMode"
                        >
                            <option :value="null" :disabled="!this.isAddEquipmentMode">
                                {{ $t('lighting.safety_classes.select_safety_class') }}
                            </option>
                            <option
                                v-for="item in getPostSafetyClasses()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('post.code') }}</span>
                        <input
                            id="code"
                            v-model="item.code"
                            :disabled="!this.isAddEquipmentMode"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>

                <template v-if="this.isAddEquipmentMode">
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="span-title">{{ $t('velho_equipment.starting_position') }}</span>
                        </div>
                        <div class="col-sm-12 nopads">
                            <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                            <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :roadInfo="item"
                            :sideRequired="false"
                            :tracksRequired="false"
                            :hideTracksSelector="true"
                            :hideSideSelector="true"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="span-title">{{ $t('velho_equipment.ending_position') }}</span>
                        </div>
                        <div class="col-sm-12 nopads">
                            <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :roadInfo="item.location_ending"
                            :sideRequired="false"
                            :tracksRequired="false"
                            :hideTracksSelector="true"
                            :hideSideSelector="true"
                            />
                        </div>
                    </div>
                </template>
                <hr class="mb-0">
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
                <linked-equipment
                    v-if="item.linked_equipment && item.linked_equipment.length > 0"
                    :linked-equipments="item.linked_equipment"
                />
            </div>

            <div class="d-flex justify-content-end col-sm-12 mt-2" v-if="!this.isAddEquipmentMode">
                <button
                    class="btn btn-secondary form-button"
                    @click.stop="close"
                >
                    {{ $t('common.close') }}
                </button>
            </div>
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {lightingHelper} from "@/components/mixins/LightingMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'LightingEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, LocationDetails, ConditionSelector, LinkedEquipment, VelhoEquipmentLocationDetailsEditor},
    mixins: [velhoHelper, mapHelper, lightingHelper, conversionModelHelper, restApi, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        close: function () {
            this.$emit('close')
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateRoadNumber(this.item.location_ending.road_num)) { return false }
            if(!this.validateRoadSection(this.item.location_ending.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.location_ending.distance)) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }

            return true
        }
    }
}
</script>

<style scoped>
.map-container {
    height: 30em;
    position: relative;
}

</style>

